<mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Foundation Trustee Payment</span>
</mat-toolbar>
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column"
    fxLayoutGap="16px"
    [@routeAnimation]="true">
    <mat-tab-group #tabGroup mat-stretch-tabs>
        <mat-tab [disabled]="!hasRole('ADMIN')" label="Process to Foundation
            Trustee">
            <mat-card *ngIf="tabGroup.selectedIndex===0">
                <div class="content" fxLayout="column" fxLayout.sm="column"
                    fxLayout.xs="column" fxLayoutGap="16px"
                    [@routeAnimation]="true">
                    <foundation-payment-table [data]='foundationPaymentDetail'
                        [tableType]="'pending'">
                    </foundation-payment-table>
                </div>

            </mat-card>
        </mat-tab>

        <mat-tab [disabled]="!hasRole('ADMIN')" label="Successfully Processed
            Applications">
            <mat-card *ngIf="tabGroup.selectedIndex===1">
                <div class="content" fxLayout="column" fxLayout.sm="column"
                    fxLayout.xs="column" fxLayoutGap="16px"
                    [@routeAnimation]="true">
                    <foundation-payment-table
                        [data]='processedFoundationPaymentDetail'
                        [tableType]="'processed'">
                    </foundation-payment-table>

                </div>

            </mat-card>
        </mat-tab>
    </mat-tab-group>
</div>